import { Component, Inject, Input, Optional } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { ValueAccessorBase } from 'app/shared/input/value-accessor-base';

@Component({
  selector: 'cbm-input-select',
  templateUrl: './cbm-input-select.component.html',
  styleUrls: ['./cbm-input-select.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: CbmInputSelectComponent, multi: true }]
})
export class CbmInputSelectComponent extends ValueAccessorBase<string> {
  @Input() id: string;
  @Input() label: string;
  @Input() inputStyle: CbmInputStyle;
  @Input() options: any[];
  @Input() selected: string;
  @Input() disabled?: boolean;
  @Input() tooltip?: string;
  @Input() disabledValues?: string[];

  constructor(@Optional() @Inject(NG_VALIDATORS) private readonly validators: any[]) {
    super(); // ValueAccessor base
  }

  public valueDisabled(option): boolean {
    if (this.disabledValues) {
      return this.disabledValues.indexOf(option) > -1;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input/cbm-input-select/cbm-input-select.component.ts